import axiosClient from "./axiosClient";

const userApi = {
    login: async (data: any) => {
        const res = await axiosClient.post("/auth/login", data);
        return res;
    },
    getUser: () => axiosClient.get("/user/profile"),
    register: (data: any) => axiosClient.post("/auth/register", data),
    logout: (data: any) => axiosClient.post("/auth/logout", data),
    getProfile: () => axiosClient.get("/user/profile"),
};

export default userApi;
